export const ERP_DEFAULT_VALUES = {
  defaultCompanyValidationPermissions: [
    'COMPANY_PERMISSIONS.COMPANY_DETAILS_EDIT',
    'COMPANY_PERMISSIONS.COMPANY_ADMINS_EDIT',
    'COMPANY_PERMISSIONS.USER_PERMISSIONS_MANAGEMENT',
  ],
  defaultCompanyDetailsEnabledPermissions: [
    'COMPANY_PERMISSIONS.COMPANY_DETAILS_EDIT',
  ],
  defaultCompanyAdminsListEnabledPermissions: [
    'COMPANY_PERMISSIONS.COMPANY_ADMINS_EDIT',
  ],
  defaultCompanyPermissionsManagemetPermissions: [
    'COMPANY_PERMISSIONS.USER_PERMISSIONS_MANAGEMENT',
  ],
};
